import { makeStyles } from '@material-ui/core';
import logo from '../../assets/logo.png';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 28,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return <img className={classes.img} src={logo} alt="Kuatro Group" />;
};

export default LogoIcon;
